export default __webpack_public_path__ + "static/media/Db5.b1a9106a.mp3";